/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItemsGridSeller_sellerItems$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainer_sellerItems$ref: FragmentReference;
export type PdpRespContainer_sellerItems = {|
  +$fragmentRefs: PdpRespSimilarItemsGridSeller_sellerItems$ref,
  +$refType: PdpRespContainer_sellerItems$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainer_sellerItems",
  "type": "moreLikeThisConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGridSeller_sellerItems",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ce2dcab9626125ffef79df7339eb9c41';
module.exports = node;
